import React, { useContext } from 'react';
import listContext from '../list_context';

export const AddButton = (props) => {
  const stt = useContext(listContext);

  return <button onClick={() => stt.addNew(props.pd)} className={props.className}>{props.btnText}</button>;
};
